import {Component, store, constant} from 'Generic';
import {DEDICATED_IP_ICON, addonIconMap} from 'Generic/constants/addonIcons';
import {
  numberFormat,
  getTranslation,
  addCurrencySymbol,
  calculatePowerPackDiscountedPrice,
  calculatePowerPackMonthlyOldPrice,
  calculateDiscountedAmountAndPercentage,
} from 'Generic/lib';

export default class Addons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#addons-wrapper'),
      state: store.state,
    });
  }

  render() {
    const allAddonsArapper = document.querySelector('#all-addons-wrapper');

    const {
      PURE_KEEP,
      PURE_CRYPT,
      PURE_SCAN,
      PURE_VPN,
      specialAddonList,
      specialDiscountedAddonList,
      PORT_FORWARDING_DEDICATED_IP,
      excludeAddonsOnTrial,
      addonWithExtraMonth,
    } = constant;

    const addonsToBeHideFromDisplay = [...specialAddonList, ...specialDiscountedAddonList];
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const addonList = selectedPlan.addons ? selectedPlan.addons : [];
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : 'test';
    const disabledAddons = this.state.disable_addons ? this.state.disable_addons : [];
    const trialLength = Number(selectedPlan?.trial_length || 0);

    const noShowAddonPopupArray = [PURE_KEEP, PURE_CRYPT, PURE_SCAN, PURE_VPN];

    const currencyCode = this.state.currency_code;
    const oldPrices = this.state.old_prices;
    const oldAddonPrices = oldPrices[currencyCode] || {};

    let addonsHtml = '';
    let addAllAddonsHtml = '';

    let discountedPowerPackTotal = calculatePowerPackDiscountedPrice();
    discountedPowerPackTotal = Number(discountedPowerPackTotal) / Number(selectedPlan.months);

    const powerPackMonthlyOldPrice = calculatePowerPackMonthlyOldPrice();

    let addAllAddonDiscount;
    if (powerPackMonthlyOldPrice > discountedPowerPackTotal) {
      const [powerPackDiscount] = calculateDiscountedAmountAndPercentage(Number(powerPackMonthlyOldPrice), discountedPowerPackTotal);
      addAllAddonDiscount = powerPackDiscount;
    }

    if (addonList.length) {
      for (const addon of addonList) {
        const effectiveMonths = addonWithExtraMonth.includes(addon.code) ? selectedPlan.months : selectedPlan.interval_length;
        const addonTitle = getTranslation(addon.code);
        const addonPrice = Number(addon.unit_amount) / Number(effectiveMonths);

        const priceOldAddon = oldAddonPrices[addon?.code] ? Number(oldAddonPrices[addon?.code]) : 0;
        const showPriceOldAddon = priceOldAddon > addonPrice ? addCurrencySymbol(numberFormat(priceOldAddon)) : '';

        // For Trials remove Dedicated Server Addon
        const trialCondition = excludeAddonsOnTrial.includes(addon?.code) && trialLength > 0;
        if (trialCondition) {
          continue;
        }

        // * Addon Icons conditions object
        const addonIcon = addonIconMap[addon?.code] || DEDICATED_IP_ICON;

        const addonConditions =
          addon.state === 'active' &&
          addon.optional == '1' &&
          !addonsToBeHideFromDisplay.includes(addon.code) &&
          addon.code !== this.state.pre_selected_addon;

        if (addonConditions) {
          if (addon.code === PORT_FORWARDING_DEDICATED_IP) {
            addAllAddonsHtml += `          
            <div data-eventname="addon_visibility" data-eventtype="${addon.code}" addon-code="${
              addon.code
            }" data-eventtrigger="visible" class="addon-box addon-btn ${addon.code} ${
              selectedAddons.includes(addon.code) ? 'unselect-box active' : ''
            } ${disabledAddons.includes(addon.code) && 'disabled-box'}">
              <div data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_accord_box_click|${
                addon.code
              }" class="addon-container row">
                  <div class="col-sm-8">
                      <span class="addon-label">
                          <span class="addon-title"><h3>${getTranslation('add_all_addons')}</h3></span>
                      </span>
                  </div>
                  <div class="col-sm-4">
                    <span class="addon-label addon-price-span ${selectedAddons.includes(addon.code) && 'hide'}">
                      <i id="addon_ppm" class="addon-currency-text cut-price">${showPriceOldAddon}</i>
                      <i id="addon_ppm" class="addon-currency-text addon-price">${addCurrencySymbol(numberFormat(addonPrice))}</i>
                      <span class="per-month">/${getTranslation('mo')}</span>
                    </span>

                    <div data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_accord_cta|${
                      addon.code
                    }" class="addon-button-label">
                      <button type="button" class="addon-btn" addon-code="${addon.code}"
                      ${selectedAddons.includes(addon.code) && "style='display:none;'"}
                      ${disabledAddons.includes(addon.code) && 'disabled="disabled"'}
                      >
                        <span id="addon_${addon.code}" addon-code="${addon.code}" class="addon-name icon-plus"></span>
                      </button>
                     
                    </div>

                    <div class="addon-button-label">
                      <button type="button" class="remove-btn"
                        addon-code="${addon.code}"
                        ${selectedAddons.includes(addon.code) && "style='display: inline-block;'"}
                        data-eventname="addon_remove"
                        data-eventtype="${addon.code}"
                        data-eventtrigger="click"
                      >
                        <span addon-code="${addon.code}" class="addon-name icon-check"></span>
                      </button>
                      <div class="hide-img">
                        <span class="remove-addon-text">${getTranslation('addon_added')}</span>
                      </div>
                    </div>

                  </div>
                </div>
            </div>`;
          } else {
            addonsHtml += `          
            <div data-eventname="addon_visibility" data-eventtype="${addon.code}" addon-code="${
              addon.code
            }" data-eventtrigger="visible" class="addon-box addon-btn ${addon.code} ${
              selectedAddons.includes(addon.code) ? 'unselect-box active' : ''
            } ${disabledAddons.includes(addon.code) && 'disabled-box'}">
              <div data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_accord_box_click|${
                addon.code
              }" class="addon-container row">
                  <div class="col-sm-8">
                      <span class="addon-label">
                      <span class="addon-icon">${addonIcon}</span>
                          <span class="addon-title">${addonTitle}</span>
                          <i data-eventname="cro_info_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_accord|${
                            addon.code
                          }" class="popup_link" addon-code="${addon.code}">
                              <svg class="icon-helper" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.5" d="M6.1002 9.59377C6.26946 9.59377 6.41144 9.53642 6.52614 9.42172C6.64084 9.30702 6.69799 9.16524 6.69759 8.99638V6.60679C6.69759 6.43752 6.64024 6.29554 6.52554 6.18084C6.41084 6.06614 6.26906 6.00899 6.1002 6.00939C5.93093 6.00939 5.78895 6.06674 5.67425 6.18144C5.55955 6.29614 5.5024 6.43792 5.5028 6.60679V8.99638C5.5028 9.16564 5.56015 9.30762 5.67485 9.42232C5.78955 9.53702 5.93133 9.59417 6.1002 9.59377ZM6.1002 4.8146C6.26946 4.8146 6.41144 4.75724 6.52614 4.64254C6.64084 4.52784 6.69799 4.38606 6.69759 4.2172C6.69759 4.04794 6.64024 3.90595 6.52554 3.79125C6.41084 3.67655 6.26906 3.6194 6.1002 3.6198C5.93093 3.6198 5.78895 3.67715 5.67425 3.79185C5.55955 3.90655 5.5024 4.04833 5.5028 4.2172C5.5028 4.38646 5.56015 4.52844 5.67485 4.64314C5.78955 4.75784 5.93133 4.81499 6.1002 4.8146ZM6.1002 12.5808C5.2738 12.5808 4.49718 12.4238 3.77035 12.11C3.04351 11.7962 2.41127 11.3706 1.87361 10.8334C1.33595 10.2957 0.910405 9.66347 0.59697 8.93664C0.283535 8.2098 0.126619 7.43319 0.126221 6.60679C0.126221 5.78039 0.283137 5.00377 0.59697 4.27694C0.910803 3.5501 1.33635 2.91786 1.87361 2.3802C2.41127 1.84254 3.04351 1.417 3.77035 1.10356C4.49718 0.790127 5.2738 0.633211 6.1002 0.632812C6.9266 0.632812 7.70321 0.789729 8.43005 1.10356C9.15688 1.41739 9.78913 1.84294 10.3268 2.3802C10.8644 2.91786 11.2902 3.5501 11.604 4.27694C11.9179 5.00377 12.0746 5.78039 12.0742 6.60679C12.0742 7.43319 11.9173 8.2098 11.6034 8.93664C11.2896 9.66347 10.864 10.2957 10.3268 10.8334C9.78913 11.371 9.15688 11.7968 8.43005 12.1106C7.70321 12.4244 6.9266 12.5812 6.1002 12.5808Z" fill="#949C9E"></path>
                              </svg>
                          </i>
                      </span>
                  </div>
                  <div class="col-sm-4">
                    <span class="addon-label addon-price-span ${selectedAddons.includes(addon.code) && 'hide'}">
                      <i id="addon_ppm" class="addon-currency-text cut-price ${!showPriceOldAddon && 'hidden'}">${showPriceOldAddon}</i>
                      <i id="addon_ppm" class="addon-currency-text addon-price">${addCurrencySymbol(numberFormat(addonPrice))}</i>
                      <span class="per-month">/${getTranslation('mo')}</span>
                    </span>

                    <div data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_accord_cta|${
                      addon.code
                    }" class="addon-button-label">
                      <button type="button" class="addon-btn" addon-code="${addon.code}"
                      ${selectedAddons.includes(addon.code) && "style='display:none;'"}
                      ${disabledAddons.includes(addon.code) && 'disabled="disabled"'}
                      >
                        <span id="addon_${addon.code}" addon-code="${addon.code}" class="addon-name icon-plus"></span>
                      </button>
                     
                    </div>

                    <div class="addon-button-label">
                      <button type="button" class="remove-btn"
                        addon-code="${addon.code}"
                        ${selectedAddons.includes(addon.code) && "style='display: inline-block;'"}
                        data-eventname="addon_remove"
                        data-eventtype="${addon.code}"
                        data-eventtrigger="click"
                      >
                        <span addon-code="${addon.code}" class="addon-name icon-check"></span>
                      </button>
                      <div class="hide-img">
                        <span class="remove-addon-text">${getTranslation('addon_added')}</span>
                      </div>
                    </div>

                  </div>
                </div>
            </div>`;
          }
        }

        /* Addons info popup add addon button handling */
        const addonInfoPopupWrapper = document.querySelector(`.addons-info-popups #${addon.code}_info_popup`);
        const addonInfoPopupAddBtn = addonInfoPopupWrapper?.querySelector('.addon-modal-btn') || null;

        if (addonInfoPopupAddBtn) {
          let addonInfoPopupAddBtnDisplay = 'block';

          if ([...selectedAddons, ...disabledAddons].includes(addon.code)) {
            addonInfoPopupAddBtnDisplay = 'none';
          }

          if (noShowAddonPopupArray.includes(addon.code)) {
            addonInfoPopupAddBtnDisplay = 'none';
          }
          addonInfoPopupAddBtn.style.display = addonInfoPopupAddBtnDisplay;
        }
      }
    }

    this.element.innerHTML = addonsHtml;
    allAddonsArapper.innerHTML = addAllAddonsHtml;
  }
}
